import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { register as registerServiceWorker } from "@/serviceWorkerRegistration";

// Apply the saved theme immediately, before React renders, to avoid a
// dark→light flash on first paint.
try {
  const saved = localStorage.getItem("soulmatch_theme");
  const theme = saved === "dark" ? "dark" : "light";
  if (theme === "light") document.body.classList.add("alvorada");
} catch { /* localStorage disabled — ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
